import api from "../../index.js";

export const GetWithdrawApi = () => api.get(`WalletMaster/Get-Withdraw-Type`);
export const GetWithdrawnewApi = (params) => api.get(`Withdraw/GetWithdraw-RequestByUserId?${params}`);
export const GetWalletApi = (userId, params) => api.get(`WalletMaster/Get-WalletDetailsByRule/${userId}?${params}`);
export const AddWithdrawRequestApi = (data) => api.post('Withdraw/Create-Withdraw-Request', data);

export const VerifyWithdrawTransactionApi = (data) => api.post('Withdraw/Verify-transaction-OTP', data);
export const ResendWithdrawTransactionApi = (data) => api.post('Withdraw/Resend-transaction-OTP', data);

export const Match2PayWithdrawApi = (data) => api.post('WalletMaster/Match2Pay-Withdraw-Request', data);
export const CregisWithdrawApi = (data) => api.post('PaymentGateway/Cregis-Withdraw-Request', data);
